import ListOperationalUsers from './ListUsers';
export default ListOperationalUsers;
